/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageLotsDto } from '../../models/usage-lots-dto';

export interface GetUsageLots$Params {
  from?: string;
  to?: string;
  partId?: number;
  'X-API-Version'?: string;
}

export function getUsageLots(http: HttpClient, rootUrl: string, params?: GetUsageLots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLotsDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageLots.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('partId', params.partId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageLotsDto>;
    })
  );
}

getUsageLots.PATH = '/api/usage-statistics/lots';
